var chunkToChildrenMap = {
	"1622": [
		2155,
		1134,
		4526,
		2147,
		9010,
		7807,
		449
	],
	"8960": [
		5006,
		6685
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };